import React from 'react';
import { useToast } from './ToastProvider';

export interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
interface ErrorBoundaryState { hasError: boolean; }

class ErrorBoundaryInner extends React.Component<ErrorBoundaryProps & { onError: (error: unknown, info: unknown) => void }, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };
  static getDerivedStateFromError(): ErrorBoundaryState { return { hasError: true }; }
  componentDidCatch(error: unknown, info: unknown) {
    this.props.onError(error, info);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="p-4 bg-red-50 text-red-800 rounded" data-testid="error-fallback">Ein unerwarteter Fehler ist aufgetreten.</div>
      );
    }
    return this.props.children;
  }
}

export function ErrorBoundary(props: ErrorBoundaryProps) {
  const { error } = useToast();
  const handle = (e: unknown) => {
    let msg = 'Unerwarteter Fehler';
    if (e && typeof e === 'object' && 'message' in e) msg = String((e as any).message || msg);
    error(msg);
  };
  return <ErrorBoundaryInner {...props} onError={handle} />;
}
